import { icon as faIconLib } from '@fortawesome/fontawesome-svg-core';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { CATEGORY_META } from '../constants/kart';

export function transformWpPost(post) {
    const meta = post.kart_meta || {};
    return {
        id: post.id,
        name: post.title?.rendered || '',
        category: meta.kategori || 'annet',
        description: meta.beskrivelse || '',
        coordinates: [parseFloat(meta.lng) || 0, parseFloat(meta.lat) || 0],
        link: meta.link || null,
        linkLabel: meta.link_label || 'Les mer'
    };
}

// Builds a span containing a FontAwesome SVG. The SVG string from the
// FA library is trusted; only it is ever assigned via innerHTML here.
function createIconSpan(faIcon, className) {
    const span = document.createElement('span');
    span.className = className;
    const result = faIconLib(faIcon);
    span.innerHTML = result ? result.html[0] : '';
    return span;
}

export function createMarkerElement(category, name) {
    const meta = CATEGORY_META[category] || CATEGORY_META.annet;
    const el = document.createElement('button');
    el.className = `kart-pin kart-pin--${category}`;
    el.setAttribute('aria-label', name || meta.label);

    const iconResult = faIconLib(meta.icon);
    const svgHtml = iconResult ? iconResult.html[0] : '';

    el.innerHTML = `
        <span class="kart-pin__circle" style="background-color:${meta.bg};border-color:${meta.color};color:${meta.color}">
            <span class="kart-pin__icon">${svgHtml}</span>
        </span>
    `;

    return el;
}

// Builds a GeoJSON FeatureCollection of POI name labels for the MapLibre
// symbol layer — MapLibre then handles label collision/decluttering natively.
export function buildLabelGeoJSON(locations) {
    return {
        type: 'FeatureCollection',
        features: locations.map(loc => ({
            type: 'Feature',
            geometry: { type: 'Point', coordinates: loc.coordinates },
            properties: { name: loc.name, category: loc.category }
        }))
    };
}

// Builds the DOM content for a POI popup bubble. WP-sourced text (name,
// description, link label) is always set via textContent; innerHTML is
// used only for trusted FontAwesome SVG strings.
export function createPopupContent(location) {
    const meta = CATEGORY_META[location.category] || CATEGORY_META.annet;

    const body = document.createElement('div');
    body.className = 'kart-popup__body';

    const badge = document.createElement('div');
    badge.className = 'kart-popup__badge';
    badge.style.backgroundColor = meta.bg;
    badge.style.color = meta.color;
    badge.style.borderColor = meta.color;
    badge.appendChild(createIconSpan(meta.icon, 'kart-popup__badge-icon'));
    badge.appendChild(document.createTextNode(meta.label));
    body.appendChild(badge);

    const title = document.createElement('h3');
    title.className = 'kart-popup__title';
    title.textContent = location.name;
    body.appendChild(title);

    if (location.description) {
        const desc = document.createElement('p');
        desc.className = 'kart-popup__desc';
        desc.textContent = location.description;
        body.appendChild(desc);
    }

    if (location.link) {
        const link = document.createElement('a');
        link.className = 'kart-popup__link';
        link.href = location.link;
        link.target = '_blank';
        link.rel = 'noreferrer';
        link.style.color = meta.color;
        link.style.borderColor = meta.color;
        link.appendChild(document.createTextNode(location.linkLabel || 'Les mer'));
        link.appendChild(createIconSpan(faArrowUpRightFromSquare, 'kart-popup__link-icon'));
        body.appendChild(link);
    }

    return body;
}
